import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { reportAPI } from '../../services/api';

const Charts = () => {
  const { user } = useAuth();
  const [visitData, setVisitData] = useState({});
  const [salesData, setSalesData] = useState({});

  useEffect(() => {
    fetchChartData();
  }, []);

  const fetchChartData = async () => {
    try {
      const [visitsRes, salesRes] = await Promise.all([
        reportAPI.getVisitsReport(),
        reportAPI.getSalesReport()
      ]);
      
      setVisitData(visitsRes.data.data?.summary || {});
      setSalesData(salesRes.data.data?.summary || {});
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }
  };

  // Simple bar chart renderer
  const renderBarChart = (data, label) => {
    if (!data || Object.keys(data).length === 0) {
      return <p className="text-gray-500 text-center py-4">No data available</p>;
    }

    const entries = Object.entries(data).slice(0, 6);
    const maxValue = Math.max(...entries.map(([, value]) => value));

    return (
      <div className="space-y-3">
        {entries.map(([name, value]) => (
          <div key={name} className="flex items-center gap-3">
            <span className="text-sm text-gray-600 w-24 truncate">{name}</span>
            <div className="flex-1 bg-gray-200 rounded-full h-6 overflow-hidden">
              <div
                className="h-full bg-teal-500 rounded-full transition-all duration-500"
                style={{
                  width: `${(value / (maxValue || 1)) * 100}%`,
                  minWidth: '4px'
                }}
              />
            </div>
            <span className="text-sm font-medium text-gray-700 w-16 text-right">
              {typeof value === 'number' && value > 1000 
                ? `₹${(value / 1000).toFixed(1)}k` 
                : value}
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Visits by Type
        </h3>
        {renderBarChart(visitData.byType, 'Visit Type')}
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Sales by Product
        </h3>
        {renderBarChart(salesData.byProduct, 'Product')}
      </div>
    </div>
  );
};

export default Charts;